<div class="container-margin">
  <div class="row">
    <h2>{{ translationService.getIngredientsText() }}</h2>
  </div>

  <div class="container">
    <form [formGroup]="filterForm">
      <div [ngClass]="!isMobileView ? 'grid-container' : ''">
        <mat-form-field
          [ngClass]="isMobileView ? 'filter-option-mobile' : 'filter-option'"
          appearance="outline"
        >
          <mat-label>{{ translationService.getNameText() }}</mat-label>
          <input
            matInput
            formControlName="name"
            type="text"
            name="name"
            appDisallowQuotes
          />
        </mat-form-field>

        <mat-form-field
          [ngClass]="isMobileView ? 'filter-option-mobile' : 'filter-option'"
          appearance="outline"
        >
          <mat-label>{{ translationService.getCasNumberText() }}</mat-label>
          <input
            matInput
            formControlName="casNumber"
            type="text"
            name="casNumber"
            appDisallowQuotes
          />
        </mat-form-field>
      </div>

      <div [ngClass]="!isMobileView ? 'row form-row align-right' : ''">
        <button
          mat-stroked-button
          color="primary"
          [ngClass]="isMobileView ? 'filter-button-mobile' : 'filter-button'"
          type="button"
          (click)="resetFilter()"
        >
          <mat-icon>refresh</mat-icon>
          {{ translationService.getResetFilterText() }}
        </button>
        <button
          mat-raised-button
          color="primary"
          [ngClass]="isMobileView ? 'filter-button-mobile' : 'filter-button'"
          type="button"
          [disabled]="isFilterButtonDisabled()"
          (click)="getIngredientList()"
        >
          <mat-icon>search</mat-icon>
          {{ translationService.getFilterResultsText() }}
        </button>
        @if (isAdmin || isComplianceOfficer) {
          <button
            mat-raised-button
            color="accent"
            [ngClass]="isMobileView ? 'filter-button-mobile' : 'filter-button'"
            type="button"
            (click)="goToCreate()"
          >
            <mat-icon>add</mat-icon>
            {{ translationService.getCreateText() }}
          </button>
          <button
            mat-raised-button
            color="accent"
            [ngClass]="isMobileView ? 'filter-button-mobile' : 'filter-button'"
            type="button"
            (click)="goToImport()"
          >
            <mat-icon>add</mat-icon>
            {{ translationService.getImportText() }}
          </button>
        }
      </div>

      <h2>
        <span
          >{{ ingredients.totalRecords }}
          {{ translationService.getResultOptionalSText() }}</span
        >
      </h2>
      <app-ingredient-list
        [ingredients]="ingredients.results"
        [displayedColumns]="displayedColumns"
      ></app-ingredient-list>

      <mat-paginator
        (page)="changePage($event)"
        [length]="ingredients.totalRecords"
        showFirstLastButtons
        pageSize="20"
      ></mat-paginator>
    </form>
  </div>
</div>
